import {useEffect, useMemo, useState} from "react";
import {isEqual} from "lodash";

const applyOrder = (baselineIds: number[], override: number[] | null): number[] => {
  if (!override) return baselineIds;
  const overridden = new Set(override);
  if (baselineIds.some((id) => !overridden.has(id))) return baselineIds;
  const live = new Set(baselineIds);
  return override.filter((id) => live.has(id));
};

export const useRowOrder = (baselineIds: number[]) => {
  const [override, setOverride] = useState<number[] | null>(null);
  const orderedIds = useMemo(() => applyOrder(baselineIds, override), [baselineIds, override]);
  const hasChanges = !isEqual(orderedIds, baselineIds);

  useEffect(() => {
    if (!hasChanges) return;
    const warnBeforeLeaving = (event: BeforeUnloadEvent) => event.preventDefault();
    window.addEventListener("beforeunload", warnBeforeLeaving);
    return () => window.removeEventListener("beforeunload", warnBeforeLeaving);
  }, [hasChanges]);

  return {orderedIds, hasChanges, reorder: setOverride, discard: () => setOverride(null)};
};
